export const initProfileTranslate = (): void => {
  const profile = document.getElementById("profile") as HTMLDivElement;

  if (!profile) {
    return;
  }

  const descriptionWrapper = profile.querySelector(".description-wrapper") as HTMLDivElement;

  if (!descriptionWrapper) {
    return;
  }

  const translate = profile.querySelector(".translate") as HTMLDivElement;

  if (!translate) {
    return;
  }

  const buttonTranslate = translate.querySelector("button") as HTMLButtonElement;
  const spinner = translate.querySelector(".spinner") as HTMLSpanElement;

  const description = descriptionWrapper.querySelector(".description") as HTMLParagraphElement;
  const descriptionFull = descriptionWrapper.querySelector(
    ".description-full",
  ) as HTMLParagraphElement;

  buttonTranslate.addEventListener("click", (e) => {
    e.preventDefault();

    if (buttonTranslate.disabled) {
      return;
    }

    //show spinner
    spinner.classList.remove("d-none");
    buttonTranslate.disabled = true; // disable button until finished

    const userId = buttonTranslate.dataset.userId;
    const toggleDescription = buttonTranslate.dataset.toggleDescription;
    const toggleDescriptionFull = buttonTranslate.dataset.toggleDescriptionFull
      ? buttonTranslate.dataset.toggleDescriptionFull
      : null;

    // toggle translation and original
    if (toggleDescription !== undefined) {
      buttonTranslate.dataset.toggleDescription = description.textContent
        ? description.textContent
        : undefined;
      buttonTranslate.dataset.toggleDescriptionFull = descriptionFull.textContent
        ? descriptionFull.textContent
        : undefined;

      description.textContent = toggleDescription;
      descriptionFull.textContent = toggleDescriptionFull;

      const textTranslate = buttonTranslate.querySelector(".text-translate") as HTMLSpanElement;
      textTranslate.classList.toggle("d-none");

      const textOriginal = buttonTranslate.querySelector(".text-original") as HTMLSpanElement;
      textOriginal.classList.toggle("d-none");

      const disclaimer = translate.querySelector(".disclaimer") as HTMLParagraphElement;
      disclaimer.classList.toggle("d-none");

      spinner.classList.add("d-none");
      buttonTranslate.disabled = false;

      return;
    }

    fetch(`/website-api/user/${userId}/description/translate/`, {
      credentials: "same-origin",
      method: "get",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.metadata.code === 406) {
          // Target language invalid
          alert(json.metadata.error_message);
          return;
        }

        // Store original descriptions in dataset
        buttonTranslate.dataset.toggleDescription = description.textContent
          ? description.textContent
          : undefined;
        buttonTranslate.dataset.toggleDescriptionFull = descriptionFull.textContent
          ? descriptionFull.textContent
          : undefined;

        description.textContent = json.data.translated_description_truncated;
        descriptionFull.textContent = json.data.translated_description;

        const textTranslate = buttonTranslate.querySelector(".text-translate") as HTMLSpanElement;
        textTranslate.classList.toggle("d-none");

        const textOriginal = buttonTranslate.querySelector(".text-original") as HTMLSpanElement;
        textOriginal.classList.toggle("d-none");

        const disclaimer = translate.querySelector(".disclaimer") as HTMLParagraphElement;
        disclaimer.classList.remove("d-none");

        spinner.classList.add("d-none");
        buttonTranslate.disabled = false;
      });
  });
};
